module.exports = __webpack_public_path__ + "img/11.e2717edb.png";